module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [_c('el-row', [_c('BigImg', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showImg),
      expression: "showImg"
    }],
    staticStyle: {
      "z-index": "1001"
    },
    attrs: {
      "imgSrc": _vm.imgSrc
    },
    on: {
      "click": function($event) {
        return _vm.viewImg()
      }
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseDormVisible),
      expression: "chooseDormVisible"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "padding-top": "20px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "dormSetForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.dormSetForm,
      "label-width": "90px"
    }
  }, [_c('el-row', [_c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "left"
    },
    attrs: {
      "src": _vm.effectDrawing
    },
    on: {
      "click": function($event) {
        return _vm.clickImg($event)
      }
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "right"
    },
    attrs: {
      "src": _vm.bedDiagram
    },
    on: {
      "click": function($event) {
        return _vm.clickImg($event)
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "收费标准"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.price))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "规格"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.dormStandard))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "宿舍配置"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.roomSet))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公共配置"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.pubAreaSet))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所在区域"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.region))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSetForm.remark))])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "dormChooseForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "inline": _vm.global.editInline,
      "model": _vm.dormChooseForm,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公寓"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('flatsName', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['flatsName']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'flatsName', $$v)
      },
      expression: "dormChooseForm['flatsName']"
    }
  }, _vm._l((_vm.modeSelector('Flats')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍类型"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('dormSet', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['dormSet']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'dormSet', $$v)
      },
      expression: "dormChooseForm['dormSet']"
    }
  }, _vm._l((_vm.modeSelector('Dorm_Set')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('roomNo', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['roomNo']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'roomNo', $$v)
      },
      expression: "dormChooseForm['roomNo']"
    }
  }, _vm._l((_vm.modeSelector('Room')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "床位"
    }
  }, [_c('el-select', {
    class: _vm.Ginkgo.getEditItemClass(_vm.global.editInline),
    attrs: {
      "placeholder": "== 请选择 ==",
      "disabled": _vm.getDisableEdit('bedNo', 'form')
    },
    model: {
      value: (_vm.dormChooseForm['bedNo']),
      callback: function($$v) {
        _vm.$set(_vm.dormChooseForm, 'bedNo', $$v)
      },
      expression: "dormChooseForm['bedNo']"
    }
  }, _vm._l((_vm.modeSelector('Bed')), function(option) {
    return _c('el-option', {
      key: option.modeId,
      attrs: {
        "label": option.modeName,
        "value": option.modeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("四人间床位  总计: " + _vm._s(_vm.fourBedSum) + "  剩余：" + _vm._s(_vm.fourBedRmi) + "  ")])]), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("六人间床位  总计: " + _vm._s(_vm.sixBedSum) + "  剩余：" + _vm._s(_vm.sixBedRmi) + "  ")])]), _vm._v(" "), _c('el-form-item', [_c('span', {
    staticClass: "deg-title"
  }, [_vm._v("八人间床位  总计: " + _vm._s(_vm.eightBedSum) + "  剩余：" + _vm._s(_vm.eightBedRmi) + "  ")])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "disabled": _vm.disabledBtn
    },
    on: {
      "click": function($event) {
        return _vm.addBed()
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chooseDormSelectedVisible),
      expression: "chooseDormSelectedVisible"
    }]
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "padding-top": "20px"
    }
  }, [_c('el-row', {
    staticStyle: {
      "background-color": "#fff",
      "text-align": "center"
    }
  }, [_c('el-form', {
    ref: "dormSelectedSetForm",
    staticStyle: {
      "width": "50%",
      "background-color": "#fff",
      "margin": "auto"
    },
    attrs: {
      "model": _vm.dormSelectedSetForm,
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-row', [_c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "left"
    },
    attrs: {
      "src": _vm.effectDrawing
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "banner-img",
    staticStyle: {
      "width": "50%",
      "height": "150px",
      "float": "right"
    },
    attrs: {
      "src": _vm.bedDiagram
    }
  })]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item"
  }), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公寓："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.flatsName))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍类型："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.dormSet))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.roomNo))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "床位："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.bedNo))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "收费标准："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.price))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "宿舍配置："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.roomSet))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "公共配置："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.pubAreaSet))])]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form-item",
    attrs: {
      "label": "所在区域："
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.dormSelectedSetForm.region))])])], 1), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "text-align": "center",
      "padding": "10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.toHome()
      }
    }
  }, [_vm._v("去首页")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f038206","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/XiFan/DormOld.vue
// module id = 1274
// module chunks = 1